import { useMutation } from '@tanstack/react-query';
import { DeviceConfigData } from '../models/device-config';
import { customFetchV2 } from '../services/custom-fetch-v2';

interface UpdateDeviceConfigRequest {
  deviceId: string;
  config: DeviceConfigData;
}

interface UpdateDeviceConfigResponse {}

/**
 * API call to update device profile.
 */
const updateDeviceConfig =
  async (request: UpdateDeviceConfigRequest): Promise<UpdateDeviceConfigResponse | null> => {
    const { deviceId, config } = request;

    const response: any = await customFetchV2(`/api/v2/devices/${deviceId}/config`, {
      method: 'POST',
      body: JSON.stringify({ config }),
    });

    if (!response.ok) {
      throw new Error('Unable to update user phone');
    }

    return {};
  };

const useUpdateDeviceConfigMutation = () => {
  return useMutation({
    mutationFn: updateDeviceConfig,
    onSuccess: () => {
      // TODO: Would make sense to invalidate related queries in here.. just need
      // to get hold of device ID and device profile ID
    },
  });
};

/** Exports */
export { useUpdateDeviceConfigMutation };
